import { filter } from 'rxjs/operators';
import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavParams, NavController, Platform } from '@ionic/angular';
import { DynamicFormBuildConfig, DynamicFormConfiguration, RxDynamicFormBuilder } from "@rxweb/reactive-dynamic-forms";
import { tempDynamicStoreconfig } from 'src/app/shared/tempDynamicStoreconfig';
// import { isArray } from 'util';
import { AppService } from 'src/app/services/app.service';
import { AppEnum } from 'src/app/appenum';
import { AppSettings } from 'src/app/app.settings';
import { EncryptionService } from 'src/app/services/encryption.service';
import { register } from 'swiper/element/bundle';
import { AppNavigation } from 'src/app/services/app-navigation';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from 'src/app/services/logging.service';
import { IdbService } from 'src/app/services/idb.service';
import { TranslateService } from '@ngx-translate/core';
register();
@Component({
  selector: 'app-modal-confirmaddress',
  templateUrl: './modal-confirmaddress.component.html',
  styleUrls: ['./modal-confirmaddress.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalConfirmaddressComponent implements OnInit {
  @Input() latitude: string;
  @Input() longitude: string;
  @Input() accuracy: string;
  @Input() address: string;
  @Input() pagename: string;
  @Input() lastSelectedTierDetails;
  @Input() slideIndex: any;
  @Input() capturedImagePath: string;

  public selectedZoneCategory;
  public isShowExamples = false;
  public showingExampleFor;
  public confirmAddressHelpGuide;
  selectedIndex: any;
  public showchildren: any;
  currentState: any;
  selectedCatDetails: any;
  isShow = false;
  pageName: any;
  taskId: any;
  isChildren = false;
  showImages = false;
  showCategoryImages: any;
  childrenArray: any;
  toBackonParent: any;
  sliderIndex: any;
  isparent = false;
  clickedZone: any;
  selectedZoneData: any;
  // @ViewChild('modelslide', { static: false }) slides: IonSlides;
  // @ViewChild('showexamples', { static: false }) showexamples: IonSlides;
  @ViewChild('showexamples') swiperRef: ElementRef | undefined;
  slideOpts = {
    pagination: false,
    // Space between tabs
  };
  innershowexamples
  imagearraylength: any;
  disablePrevBtn = true;
  disableNextBtn = false;
  selecedCatOnRoot: any;
  label: number = 2;
  multipleimage = false;
  prom1: any;
  prom2: any;
  result: any = [];
  customJsonForm: any = [];
  helpfilteredImages: any;
  repeatableControlList: any;
  parentData: any = null;
  headerTitle: any;
  componentName: string = 'modelConfirmAddress Component';
  constructor(public modalController: ModalController, public _appenum: AppEnum, private _nav: AppNavigation, public _tempDynamicFormConfig: tempDynamicStoreconfig, private navParams: NavParams, public _appServices: AppService,
    public _appSetting: AppSettings, public encryptionService: EncryptionService,
    public loggingService: LoggingService,
    public idbservice: IdbService,
    public _translateService: TranslateService) {
    wrapAllMethodsWithLogging(this, this.componentName);
    this.pageName = navParams.data.pagename;
    this.taskId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId));
  }

  async ngOnInit() {
    if (this.pagename == 'dynamic-card') {
      var templateID = this._tempDynamicFormConfig.serverData[this.slideIndex].templateId
      var mappedData = await this._tempDynamicFormConfig.jsonValueMapped(templateID)
      const clonedTemplateJson = structuredClone(mappedData.templateJson);
      const visibleOnly = clonedTemplateJson.filter(item => item.isVisible);
      this.customJsonForm = await this.get_Zone_tree_List(visibleOnly);
      // mappedData.templateJson = mappedData.templateJson.filter(item => item.isVisible); 
      // this.customJsonForm = await this.get_Zone_tree_List(mappedData.templateJson);
    } else {
      this.confirmAddressHelpGuide = this._tempDynamicFormConfig.getHelpJsonData[0]
      this.imagearraylength = this.confirmAddressHelpGuide.imgName.length;
      this.filterHelpImage(this._tempDynamicFormConfig.getHelpGuideFile, this.confirmAddressHelpGuide.imgName)
      setTimeout(() => {
        if (this.confirmAddressHelpGuide.imgName.length == 1) {
          // this.showexamples.lockSwipes(true);
        }
      }, 500);
    }
  }

  get_Zone_tree_List = (items: any, controlName = "", link = 'parent') => items
    .filter(item => item[link] == controlName)
    .map(item => ({ ...item, children: this.get_Zone_tree_List(items, item.controlName) }));

  ionViewWillEnter() {
    // console.log(this.slides);
  }

  // Showing Children Detail on click

  async getEvent(obj) {
    this._tempDynamicFormConfig.lastSelection = obj
    if (obj.controlType == 'title') {
      this.headerTitle = obj.label;
      if (obj['children'].length > 0) {
        this.parentData = obj;
        this.customJsonForm = obj['children'];
        this.getRepeatableControls();
      }
    } else if (obj.controlType == 'photos') {
      this.headerTitle = '';
      this.parentData = obj;
      this.showCategoryImages = this._tempDynamicFormConfig.getHelpJsonData.filter(item => item.parent == obj.parent && item.controlName == obj.controlName)
      console.log("this.showCategoryImages", this.showCategoryImages)
      this.isShowExamples = true;
      this.showImages = true;
      this.imagearraylength = this.showCategoryImages[0].imgName.length;
      this.filterHelpImage(this._tempDynamicFormConfig.getHelpGuideFile, this.showCategoryImages[0].imgName)
      setTimeout(() => {
        if (this.showCategoryImages[0].imgName.length == 1) {
          // this.showexamples.lockSwipes(true);
        }
      }, 500);
    }

  }

  filterHelpImage(arr1, arr2) {
    this.helpfilteredImages = arr1.filter(itemX => arr2.includes(itemX.fileName));
  }

  async backToCard() {
    if (this.parentData.parent == '') {
      const clonedTemplateJson = structuredClone(this._tempDynamicFormConfig.serverData[this.slideIndex].templateJson);
      const visibleOnly = clonedTemplateJson.filter(item => item.isVisible);
      this.customJsonForm = await this.get_Zone_tree_List(visibleOnly);
      this.parentData = null;
      this.headerTitle = '';
    } else {
      const clonedTemplateJson = structuredClone(this._tempDynamicFormConfig.serverData[this.slideIndex].templateJson);
      const visibleOnly = clonedTemplateJson.filter(item => item.isVisible);
      this.customJsonForm = await this.get_Zone_tree_List(visibleOnly, this.parentData.parent);
      for (var i = 0; i < this._tempDynamicFormConfig.serverData[this.slideIndex].templateJson.length; i++) {
        if (this.parentData.parent == this._tempDynamicFormConfig.serverData[this.slideIndex].templateJson[i]['controlName']) {
          this.parentData = this._tempDynamicFormConfig.serverData[this.slideIndex].templateJson[i];
        }
      }
    }
    this.isShowExamples = false;
  }


  getRepeatableControls() {
    var controlList = this.customJsonForm;
    this.repeatableControlList = controlList.length > 0 ? controlList.filter(item => item.isRepeatable == true) : []
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true,
    });
  }


  async gototconfiemCamera() {
    if (!this.capturedImagePath) {
      // nothing captured yet, go straight to camera
      this.proceedToCamera();
      return;
    }
    const pendingFiles = await this.idbservice.getAddressTaskFileDetails(this.taskId);
    if (pendingFiles.length > 0) {
      const alert = await this._appServices._alertController.create({
        cssClass: 'Confirmation_popup regularFonts',
        header: this._translateService.instant('common_alert_text.confirm_title_text'),
        message: this._translateService.instant('self_pwa_text.retake_image'),
        buttons: [
          {
            text: this._translateService.instant('common_btn_text.cancel_btn'),
            role: 'cancel',
            cssClass: ['confirmation_cancel_button', 'confirmation_popup_button'],
            handler: (blah) => {
            }
          }, {
            text: this._translateService.instant('common_btn_text.yes_btn'),
            cssClass: ['confirmation_ok_button', 'confirmation_popup_button'],
            handler: async () => {
              var taskDetail = {
                TaskId: this.taskId
              }
              var paramRequest = {
                httpRequest: null,
                taskDetails: taskDetail
              }
              try {
                // Delete from IndexedDB using the same key used during store
                await this.idbservice.deletePendingFiles(pendingFiles);
                this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Info, 'Delete Address Verification Photo From IndexedDB Because Of User Wants to Retake', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails)
                this.proceedToCamera();
              } catch (err) {
                console.error('Failed to delete address photo from IDB:', err);
                this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Error, 'Delete Address Verification Photo From IndexedDB Because Of User Wants to Retake', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, undefined, 'customALert')
              }
            }
          }
        ]
      });
      await alert.present();
    } else {
      this.proceedToCamera();
    }
  }

  private proceedToCamera() {
    this.modalController.dismiss({
      dismissed: true,
      action: 'openCamera',
    });
  }

  goToInspectionFormFill() {
    if (this.selecedCatOnRoot != undefined) {
      var selectedZone = this._tempDynamicFormConfig.getSelectedChildObject(this.selecedCatOnRoot.name, this.selecedCatOnRoot.parent, this.selecedCatOnRoot.controlName);
      this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this.taskId, latitude: this.latitude, longitude: this.longitude, clickedZone: JSON.stringify(selectedZone), fileId: 0 }]);
    } else {
      // var selectedZone = this._tempDynamicFormConfig.getSelectedChildObject(this.selectedCatDetails.name, this.selectedCatDetails.parent, this.selectedCatDetails.controlName);
      let selectedCOntrolDetails = { templateId: this._tempDynamicFormConfig.serverData[this.slideIndex].templateId, UniqueControlId: this.parentData.controlName }
      this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this.taskId, latitude: this.latitude, longitude: this.longitude, clickedZone: JSON.stringify(selectedCOntrolDetails), fileId: 0 }]);
    }
  }


  isdisable(catDetails) {
    if (catDetails.length == 0) {
      // if (catDetails.controlType == 'photos') {
      //   this.showCategoryImages = this._tempDynamicFormConfig.getHelpJsonData.filter(item => item.parent == catDetails.parent && item.controlName == catDetails.controlName)
      //   if (this.showCategoryImages.length == 0) {
      //     return false;
      //   }
      // }
    }
    else if (catDetails.children.length == 0) {
      if (catDetails.controlType == "form" || catDetails.controlType == 'comments' || catDetails.controlType == 'segment') {
        this.showCategoryImages = this._tempDynamicFormConfig.getHelpJsonData.filter(item => item.parent == catDetails.parent && item.controlName == catDetails.controlName)
        if (this.showCategoryImages.length == 0) {
          return true;
        }
      }
    }
  }

  swipeNext() {
    this.swiperRef.nativeElement.swiper.slideNext();

  }
  swipePrev() {
    this.swiperRef.nativeElement.swiper.slidePrev();
  }
  // doCheck() {

  //   if (this.disablePrevBtn == true && this.disableNextBtn == false && this.imagearraylength == 2) {
  //     this.showexamples.isBeginning().then((isbeg) => {
  //       this.disablePrevBtn = false;
  //     })
  //     this.showexamples.isEnd().then((isend) => {
  //       this.disableNextBtn = true
  //     })

  //   }

  //   else {
  //     this.showexamples.isBeginning().then((isbeg) => {
  //       this.disablePrevBtn = isbeg;
  //     })
  //     this.showexamples.isEnd().then((isend) => {
  //       this.disableNextBtn = isend
  //     })
  //   }
  // }
  closeModal() {
    this.modalController.dismiss({
    });
  }

}
